import { ACTION_POST_BASE_URL } from 'general/js/constants';

export const postTypes = Object.freeze({
    ACTION: 'action',
    BANNER_SPOT: 'banner-spot',
    LEADERBOARD: 'leaderboard',
    MEDIA: 'media',
    SOCIAL: 'social',
    STATS: 'stats',
    CLIP_TAG: 'clip-tag'
});

export const mediaTypes = Object.freeze({
    IMAGE: 'image',
    GALLERY: 'gallery',
    VIDEO_PLAYER: 'video-player'
});

export const socialTypes = Object.freeze({
    TIKTOK: 'tiktok',
    TWITTER: 'twitter',
    INSTAGRAM: 'instagram',
    YOUTUBE: 'youtube'
});

export const actionTypes = Object.freeze({
    DEFAULT: 'default',
    ALBATROSS: 'albatross',
    BIRDIE: 'birdie',
    BOGEY: 'bogey',
    BUNKER: 'bunker',
    CHAMPION_GOLFER: 'champion-golfer',
    CLUBHOUSE_LEADER: 'clubhouse-leader',
    COMING_SOON: 'coming-soon',
    CUT: 'cut',
    EAGLE: 'eagle',
    HOLE_IN_ONE: 'hole-in-one',
    HOT_STREAK: 'hot-streak',
    IN_THE_CLUBHOUSE: 'in-the-clubhouse',
    LEADER: 'leader',
    MAKING_A_CHANGE: 'making-a-change',
    MOVING_DOWN: 'moving-down',
    MOVING_UP: 'moving-up',
    ONE_TO_WATCH: 'one-to-watch',
    OUT_OF_BOUNDS: 'out-of-bounds',
    PAR_SAVED: 'par-saved',
    QUALIFIED: 'qualified',
    REACTION: 'reaction',
    SAND_SAVE: 'sand-save',
    SCRAMBLE: 'scramble',
    TEE_TIME: 'tee-time',
    TROUBLE: 'trouble',
    WEATHER_WATCH_CLOUDY: 'weather-watch-cloudy',
    WEATHER_WATCH_RAIN: 'weather-watch-rain',
    WEATHER_WATCH_WIND: 'weather-watch-wind',
    WEATHER_WATCH_RAIN_WIND: 'weather-watch-rain-wind',
    WEATHER_WATCH_SUNNY: 'weather-watch-sunny',
    WITHDRAWAL: 'withdrawal'
});

const imageMap = [
    {
        imageSrc: '/birdie',
        associatedTypes: [
            actionTypes.BIRDIE,
            actionTypes.HOT_STREAK,
            actionTypes.ALBATROSS,
        ]
    },
    {
        imageSrc: '/bogey',
        associatedTypes: [actionTypes.BOGEY]
    },
    {
        imageSrc: '/bunker',
        associatedTypes: [actionTypes.BUNKER]
    },
    {
        imageSrc: '/champion-golfer',
        associatedTypes: [actionTypes.CHAMPION_GOLFER]
    },
    {
        imageSrc: '/clubhouse-leader',
        associatedTypes: [actionTypes.CLUBHOUSE_LEADER]
    },
    {
        imageSrc: '/coming-soon',
        associatedTypes: [actionTypes.COMING_SOON]
    },
    {
        imageSrc: '/cut',
        associatedTypes: [actionTypes.CUT]
    },
    {
        imageSrc: '/eagle',
        associatedTypes: [actionTypes.EAGLE]
    },
    {
        imageSrc: '/hole-in-one',
        associatedTypes: [actionTypes.HOLE_IN_ONE]
    },
    {
        imageSrc: '/in-the-clubhouse',
        associatedTypes: [actionTypes.IN_THE_CLUBHOUSE]
    },
    {
        imageSrc: '/leader',
        associatedTypes: [actionTypes.LEADER]
    },
    {
        imageSrc: '/making-a-change',
        associatedTypes: [actionTypes.MAKING_A_CHANGE]
    },
    {
        imageSrc: '/moving-down',
        associatedTypes: [actionTypes.MOVING_DOWN]
    },
    {
        imageSrc: '/moving-up',
        associatedTypes: [actionTypes.MOVING_UP]
    },
    {
        imageSrc: '/one-to-watch',
        associatedTypes: [actionTypes.ONE_TO_WATCH]
    },
    {
        imageSrc: '/out-of-bounds',
        associatedTypes: [actionTypes.OUT_OF_BOUNDS]
    },
    {
        imageSrc: '/par-saved',
        associatedTypes: [
            actionTypes.PAR_SAVED,
            actionTypes.SAND_SAVE,
            actionTypes.SCRAMBLE
        ]
    },
    {
        imageSrc: '/qualified',
        associatedTypes: [actionTypes.QUALIFIED]
    },
    {
        imageSrc: '/reaction',
        associatedTypes: [actionTypes.REACTION]
    },
    {
        imageSrc: '/tee-time',
        associatedTypes: [actionTypes.TEE_TIME]
    },
    {
        imageSrc: '/trouble',
        associatedTypes: [actionTypes.TROUBLE]
    },
    {
        imageSrc: '/weather-watch-cloudy',
        associatedTypes: [actionTypes.WEATHER_WATCH_CLOUDY]
    },
    {
        imageSrc: '/weather-watch-rain',
        associatedTypes: [actionTypes.WEATHER_WATCH_RAIN]
    },
    {
        imageSrc: '/weather-watch-wind',
        associatedTypes: [actionTypes.WEATHER_WATCH_WIND]
    },
    {
        imageSrc: '/weather-watch-rain-wind',
        associatedTypes: [actionTypes.WEATHER_WATCH_RAIN_WIND]
    },
    {
        imageSrc: '/weather-watch-sunny',
        associatedTypes: [actionTypes.WEATHER_WATCH_SUNNY]
    },
    {
        imageSrc: '/withdrawal',
        associatedTypes: [actionTypes.WITHDRAWAL]
    }
];

export const mapActionTypeToImage = (actionType) => {
    const foundImage = imageMap.find((image) =>
        image.associatedTypes.some((type) =>
            type === actionType));

    return foundImage ? `${ACTION_POST_BASE_URL}${foundImage.imageSrc}` : '';
};

export const socialMediaJavaScriptSrc = Object.freeze({
    INSTAGRAM: 'https://www.instagram.com/embed.js',
    TIKTOK: 'https://www.tiktok.com/embed.js',
    TWITTER: 'https://platform.twitter.com/widgets.js'
});
